<template>

     <div v-if="loged" class="admin-wrapper">


    <!-- Sidebar -->
    <aside class="admin-sidebar" id="adminSidebar">

      <!-- User -->
      <div class="sidebar-user">
        <img :src="this.$store.state.img_url+'shopleo.png'" class="sidebar-avatar">
        <div class="sidebar-user-text">
          <div class="company-name text-color">Shopleo</div>
          <span class="username text-muted text-sm">{{ this.user.username }}</span>
        </div>
      </div>

      <hr class="sidebar-divider">
      <!-- Menu -->
      <ul class="sidebar-menu">
        <router-link :to="{path:'/'}">
        <li><i class="fas fa-chart-line"></i><span>Dashboard</span></li>
        </router-link>
         <router-link v-if="user.role < 3" :to="{path:'/store'}">
        <li><i class="fas fa-store"></i><span>Stores</span></li>
        </router-link>
          <router-link :to="{path:'/order'}">
        <li><i class="fas fa-shopping-cart"></i><span>Orders</span></li>
        </router-link>
         <router-link v-if="user.role == 1" :to="{path:'/sales'}">
        <li><i class="fas fa-dollar-sign"></i><span>Sales</span></li>
        </router-link>
         <router-link v-if="user.role == 1" :to="{path:'/canceled-order'}">
        <li><i class="fas fa-times"></i><span>Canceled</span></li>
        </router-link>
        
       
         <router-link  v-if="user.role < 3" :to="{path:'/clients'}">
        <li><i class="fas fa-users"></i><span>Customers</span></li>
        </router-link>
          <router-link v-if="user.role < 3" :to="{path:'/messages'}">
        <li><i class="fas fa-gem"></i><span>Messages</span></li>
        </router-link>
         <router-link :to="{path:'/staffs'}">
        <li><i class="fas fa-users"></i><span>Staffs</span></li>
        </router-link>
         <router-link :to="{path:'/profile'}">
        <li><i class="fas fa-receipt"></i><span>Profile</span></li>
        </router-link>
        
      </ul>

      <!-- Logout -->
      <div class="sidebar-logout">
        <button  @click="logout">
          <i class="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </button>
      </div>

    </aside>

    <div class="sidebar-overlay" id="sidebarOverlay"></div>


    <!-- Main -->
    <main class="admin-main">

      <!-- Header -->
      <header class="admin-header">
        <button id="sidebarToggle" class="toggle-btn d-none d-md-block">
          <i class="fas fa-bars"></i>
        </button>

                      <button class="toggle-btn d-md-none" id="menuToggle">
  <i class="fas fa-bars"></i>
</button>


        <h5 class="page-title">{{ this.$store.state.page_name }}</h5>
      </header>
      
<router-view :user="this.user" :key="$route.fullPath" />
    </main>

  </div>

<!-- Page wrapper ends min-h-screen -->

  <div v-if="!loged" class="">
      <Authentication />
  </div>


</template>

<script>
import axios from "axios";
import * as CryptoJS from 'crypto-js';
import Authentication from "./views/auth/Authentication.vue";
//import Verify from "./views/auth/Verify.vue";
//import JoinForm from "./views/JoinForm.vue"


export default {
  components: {
    Authentication,
  },
  data() {
    return {
      loged: false,
      user: {
        fullname:"Sambokile Andy",
        auth_statuses_id:0
      },
    };
  },
  methods: {
    isLoged() {
      //var user = localStorage.getItem("user");
      var user_cry = localStorage.getItem("user") || "";
      var token_cry = localStorage.getItem("user_token") || "";
      var user = CryptoJS.AES.decrypt(user_cry, 'user').toString(CryptoJS.enc.Utf8) || null
      var token = CryptoJS.AES.decrypt(token_cry, 'user_token').toString(CryptoJS.enc.Utf8) || null


      if (user && token) {
        this.loged = true;
        this.user = JSON.parse(user);
      } else {
        localStorage.removeItem("user_token")
        localStorage.removeItem("user")
        this.loged = false;
      }
    },
    logout() {
      this.$store.dispatch("logOut", { id: this.user.id ,company_id : this.user.company_id });
    },
  },
  created() {

    this.isLoged();
    //alert(localStorage.getItem("user"));
    //this.reload();
    var token_cry = localStorage.getItem("user_token") || "";
    var token = CryptoJS.AES.decrypt(token_cry, 'user_token').toString(CryptoJS.enc.Utf8) || null
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common["Authorization"] = token
  },
  mounted() {
  }
     
};
</script>